import { getItem } from '../../helper/localstorage.helper';
import { post } from '../api.service';

export const registerWithEmailAndPassword = async (user: { language: string; }) => {
    const tduid = getItem("tduid");
    const requestBody = { ...user, tduid };

    return await post(`/v2/auth/signup?lang=${user?.language}`, requestBody);
};